import * as z from "zod";

export const requestPasswordLogin = {
  name: "requestPasswordLogin" as const,
  input: z.object({ email: z.string() }),
  output: z.object({ requiresPassword: z.boolean() }),
};
